import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
const PbxVirtualOperatorCostsList = React.lazy(() =>
  import('./PbxVirtualOperatorCostsList')
);

const PbxVirtualOperatorCostsPage = (props) => (
  <PbxVirtualOperator scrolling>
    <div className="text-right">
      <HelpButton fileName="virtual-operator-costs" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <PbxVirtualOperatorCostsList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVirtualOperator>
);

export default PbxVirtualOperatorCostsPage;
